import { FC } from 'react';
import styled, { useTheme } from 'styled-components';

import { useNavigation } from '#/hooks';
import { ThemeConfig } from '#/service/config';
import { remify } from '#/service/utils';

const LogoItem = styled.img`
  width: ${remify(102)};
  min-width: ${remify(102)};
  cursor: pointer;
`;

const Logo: FC = () => {
  const theme = useTheme() as ThemeConfig;
  const { goHome } = useNavigation('Footer/Logo');

  return (
    <LogoItem
      aria-hidden="true"
      onClick={goHome}
      src={
        theme.logo?.secondary ?? theme.logo?.primary ?? theme.images?.appLogo
      }
    />
  );
};

export default Logo;
